import React, { useState, useEffect } from "react";
import Button from "./Button";
import { useStripeConnect } from "../services/useStripeConnect";
import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import { apiCreateStripeAccount } from "../services/apiService";
import stripeLogo from "../data/images/stripe-logos/stripe-wordmark-small.png";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "./LoadingSpinner";
import { useStateContext } from "../contexts/ContextProvider";
import AlertBox from "./AlertBox";

const StripeOnboardingModal = (props) => {
  const { setStripeOnboarding, lease } = props;
  const { alert, handleAlert } = useStateContext();
  const [isLoading, setIsLoading] = useState(false);
  const [accountCreatePending, setAccountCreatePending] = useState(false);
  const [onboardingExited, setOnboardingExited] = useState(false);
  const [error, setError] = useState(false);
  const [connectedAccountId, setConnectedAccountId] = useState();
  const [stripeAddress, setStripeAddress] = useState({});
  const stripeConnectInstance = useStripeConnect(connectedAccountId);

  const navigate = useNavigate();

  useEffect(() => {
    defineStripeAddress();
    // eslint-disable-next-line
  }, []);

  const defineStripeAddress = () => {
    if (lease.hasMailingAddress) {
      setStripeAddress({
        leaseId: lease.id,
        street: lease.mailingStreet,
        street2: lease.mailingStreet2,
        city: lease.mailingCity,
        state: lease.mailingState,
        zip: lease.mailingZip,
      });
    } else {
      setStripeAddress({
        leaseId: lease.id,
        street: lease.propertyStreet,
        street2: lease.propertyStreet2,
        city: lease.propertyCity,
        state: lease.propertyState,
        zip: lease.propertyZip,
      });
    }
  };

  const createStripeAccount = async () => {
    setIsLoading(true);
    setAccountCreatePending(true);
    setError(false);
    const response = await apiCreateStripeAccount(stripeAddress);
    if (response.hasError) {
      console.log(response.error);
      setError(true);
      return;
    } else {
      setConnectedAccountId(response.data.account);
    }
  };

  return (
    <div className="w-screen fixed top-0 bottom-0 grid justify-items-center overflow-y-scroll bg-white z-40">
      <LoadingSpinner isLoading={isLoading} />
      {alert.exitStripe && (
        <AlertBox
          alertType="exitStripe"
          handleAlert={handleAlert}
          alertFunc={() => {
            setStripeOnboarding(false); // non-standard modal naming
          }}
        />
      )}
      <div className="mt-28 container">
        {!onboardingExited && (
          <div className="flex justify-center text-2xl banner">
            Setup Direct Deposit
          </div>
        )}
        <div className="mt-10 mb-36 content">
          {connectedAccountId && !stripeConnectInstance && (
            <div className="text-black text-2xl">
              Add information to start accepting payments
            </div>
          )}
          {!connectedAccountId && (
            <div className="mt-10">
              <div className="p-3">
                <div className="flex justify-center">
                  <img
                    src={stripeLogo}
                    alt="Stripe Logo - Snappily's payments are powered by Stripe"
                    className="h-40"
                  />
                </div>
                <div className="flex justify-center text-snappily-orange">
                  Snappily's payments are powered by{"  "}
                  <a
                    className="text-blue-500 hover:text-blue-700 cursor-pointer pl-1"
                    href="https://stripe.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Stripe&reg;
                  </a>
                </div>
              </div>
            </div>
          )}
          {!accountCreatePending && !connectedAccountId && (
            <div className="flex justify-center w-full mt-20">
              <Button
                background="bg-slate-400"
                text="text-white"
                opacity="bg-opacity-100"
                title="Later"
                height="h-10"
                width="w-24"
                borderColor="border-none"
                borderHover="hover:border-snappily-orange"
                customFunc={() => handleAlert("exitStripe")}
              />
              <Button
                background="bg-snappily-orange"
                text="text-white"
                opacity="bg-opacity-100"
                title="Begin"
                height="h-10"
                width="w-24"
                borderColor="border-none"
                borderHover="hover:border-snappily-orange"
                customFunc={createStripeAccount}
              />
            </div>
          )}
          {stripeConnectInstance && (
            <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
              <ConnectAccountOnboarding
                onExit={() => setOnboardingExited(true)}
                onLoaderStart={() => setIsLoading(false)}
              />
            </ConnectComponentsProvider>
          )}
          {/* {accountCreatePending && !stripeConnectInstance && (
            <div>Butts are smelly!!!!</div>
          )} */}
          {error && (
            <div className="error">
              <Button
                background="bg-snappily-orange"
                text="text-white"
                opacity="bg-opacity-100"
                title="Begin"
                height="h-10"
                width="w-24"
                borderColor="border-none"
                borderHover="hover:border-snappily-orange"
                customFunc={createStripeAccount}
              />
            </div>
          )}
          {(connectedAccountId || accountCreatePending || onboardingExited) && (
            <div className="dev-callout">
              {onboardingExited && (
                <div className="flex justify-center">
                  <Button
                    background="bg-snappily-orange"
                    text="text-white"
                    opacity="bg-opacity-100"
                    title="Finished"
                    height="h-10"
                    width="w-24"
                    borderColor="border-none"
                    borderHover="hover:border-snappily-orange"
                    customFunc={() => {
                      setIsLoading(true);
                      navigate("/onboarding-return");
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StripeOnboardingModal;
